// extracted by mini-css-extract-plugin
export var logo = "_8o-2";
export var logoWrapper = "_8o-1";
export var strip = "_8o-0";